$(document).ready(function () {
  $(".menu_icon").click(function () {
    $(".menu").slideToggle(200);
    return false;
  });

  $("#nav-icon1, #nav-icon2, #nav-icon3, #nav-icon4").click(function () {
    $(this).toggleClass("open");
  });

  $(".ie_feature_slider_contents").owlCarousel({
    loop: true,
    nav: true,
    dots: true,
    autoplay: false,
    margin: 20,
    responsive: {
      0: { items: 1.1 },
      480: { items: 1.3 },
      768: { items: 1.3 },
      992: { items: 1.7 },
      1200: { items: 1.9 },
      1400: { items: 2.2 }
    }
  });

  $(".ie_feature_slider_contents .owl-prev").html('<i class="fa-solid fa-caret-left"></i>');
  $(".ie_feature_slider_contents .owl-next").html('<i class="fa-solid fa-caret-right"></i>');

  $(".ie_feature_slider_contents2").each(function () {
    var $slider = $(this);
    var $parent = $slider.closest(".ie_feature_slider");
    var $dotsContainer = $parent.find(".custom-dots-container");
    var $playBtn = $parent.find(".slider-play-btn");

    $slider.owlCarousel({
      loop: true,
      nav: false,
      dots: true,
      dotsContainer: $dotsContainer,
      autoplay: false,
      margin: 20,
      responsive: {
        0: { items: 1.2, nav: false },
        575: { items: 1.2, nav: false },
        1400: { nav: false, items: 1.1, margin: 26 }
      }
    });

    $playBtn.on("click", function () {
      var $activeItem = $slider.find(".owl-item.active .ie_feature_slider_single").first();
      var videoSrc = $activeItem.data("video-src");

      if (videoSrc) {
        var $videoPlayer = $("#slider-video-player");
        $videoPlayer.find("source").attr("src", videoSrc);
        $videoPlayer[0].load();
        $("#videoModal").modal("show");
        $videoPlayer[0].play().catch(function (e) {
          console.log("Autoplay prevented:", e);
        });
      } else {
        console.log("No video source on active slide.");
      }
    });
  });

  $("#videoModal").on("hidden.bs.modal", function () {
    var $videoPlayer = $("#slider-video-player");
    $videoPlayer[0].pause();
    $videoPlayer[0].currentTime = 0;
  });

  $(".chart-slider-contents").each(function () {
    var $slider = $(this);
    var $parent = $slider.closest(".chart-slider-wrapper");
    var $dotsContainer = $parent.find(".chart-dots-container");
    var $playBtn = $parent.find(".chart-play-btn");

    $slider.owlCarousel({
      loop: true,
      nav: false,
      dots: true,
      dotsContainer: $dotsContainer,
      autoplay: false,
      margin: 20,
      responsive: {
        0: { items: 1.2 },
        575: { items: 1.2 },
        768: { items: 1.2 },
        1200: { items: 1.1 }
      }
    });

    $playBtn.on("click", function () {
      var $activeItem = $slider.find(".owl-item.active .chart-slide-item").first();
      var videoSrc = $activeItem.data("video-src");

      if (videoSrc) {
        var $videoPlayer = $("#chart-video-player");
        $videoPlayer.find("source").attr("src", videoSrc);
        $videoPlayer[0].load();
        $("#chartVideoModal").modal("show");
        $videoPlayer[0].play().catch(function (e) {
          console.log("Autoplay prevented:", e);
        });
      } else {
        console.log("No video source on active chart slide.");
      }
    });
  });

  $("#chartVideoModal").on("hidden.bs.modal", function () {
    var $videoPlayer = $("#chart-video-player");
    $videoPlayer[0].pause();
    $videoPlayer[0].currentTime = 0;
  });

  $(".valocity-main").each(function () {
    var $section = $(this);
    var $posterContent = $section.find(".velocity-poster-content");
    var $videoWrapper = $section.find(".velocity-inline-video-wrapper");
    var $inlineVideo = $section.find(".velocity-inline-video");
    var $playBtn = $section.find(".velocity-play-btn");
    var $btnIcon = $playBtn.find("i");
    var isPlaying = false;

    $playBtn.on("click", function (e) {
      e.preventDefault();

      if (isPlaying) {
        $inlineVideo[0].pause();
        $inlineVideo[0].currentTime = 0;
        $posterContent.show();
        $btnIcon.removeClass("fa-pause").addClass("fa-play");
        isPlaying = false;
      } else {
        $posterContent.hide();
        $videoWrapper.show();
        $inlineVideo[0].play().catch(function (err) {
          console.log("Autoplay prevented:", err);
        });
        $btnIcon.removeClass("fa-play").addClass("fa-pause");
        isPlaying = true;
      }
    });

    $inlineVideo.on("ended", function () {
      $videoWrapper.hide();
      $posterContent.show();
      $btnIcon.removeClass("fa-pause").addClass("fa-play");
      $inlineVideo[0].currentTime = 0;
      isPlaying = false;
    });
  });

  $(".your_next_model_card_main").each(function () {
    var $slider = $(this);
    var $parent = $slider.closest(".your_next_model_slider_wrapper");
    var $dotsContainer = $parent.find(".your-next-mod-dots");
    var $playBtn = $parent.find(".your-next-mod-play-btn");

    $slider.owlCarousel({
      loop: true,
      nav: false,
      dots: true,
      dotsContainer: $dotsContainer,
      autoplay: false,
      margin: 20,
      responsive: {
        0: { items: 1.2 },
        575: { items: 1.2 },
        900: { items: 1.4 },
        1400: { items: 1.7, margin: 30 }
      }
    });

    $playBtn.on("click", function () {
      var $activeItem = $slider.find(".owl-item.active .your_next_model_card").first();
      var videoSrc = $activeItem.data("video-src");

      if (videoSrc) {
        var $videoPlayer = $("#your-next-mod-video-player");
        $videoPlayer.find("source").attr("src", videoSrc);
        $videoPlayer[0].load();
        $("#yourNextModVideoModal").modal("show");
        $videoPlayer[0].play().catch(function (e) {
          console.log("Autoplay prevented:", e);
        });
      } else {
        console.log("No video source on active slide.");
      }
    });
  });

  $("#yourNextModVideoModal").on("hidden.bs.modal", function () {
    var $videoPlayer = $("#your-next-mod-video-player");
    $videoPlayer[0].pause();
    $videoPlayer[0].currentTime = 0;
  });

  $(".faq-question").on("click", function () {
    var $item = $(this).closest(".faq-item");
    var $answer = $item.find(".faq-answer");
    var isActive = $item.hasClass("active");

    $(".faq-item").not($item).removeClass("active");
    $(".faq-item").not($item).find(".faq-answer").slideUp({
      duration: 400,
      easing: "swing"
    });

    if (isActive) {
      $item.removeClass("active");
      $answer.slideUp({
        duration: 400,
        easing: "swing"
      });
    } else {
      $item.addClass("active");
      $answer.slideDown({
        duration: 400,
        easing: "swing"
      });
    }
  });

  var $scrollContainer = $(".product-details-intake .left-column");
  var $menuLinks = $('.intake_menu a[href^="#"], .mobile-product-menu .menu-item[href^="#"]');

  $menuLinks.on("click", function (e) {
    var targetId = $(this).attr("href");

    if (targetId && targetId !== "#") {
      var $target = $(targetId);

      if ($target.length) {
        e.preventDefault();

        var containerScrollTop = $scrollContainer.scrollTop();
        var targetOffset = $target.offset().top - $scrollContainer.offset().top + containerScrollTop - 80;

        $scrollContainer.animate({
          scrollTop: targetOffset
        }, 600);

        $menuLinks.removeClass("active");
        $menuLinks.filter('[href="' + targetId + '"]').addClass("active");
      }
    }
  });

  $scrollContainer.on("scroll", function () {
    var scrollPos = $scrollContainer.scrollTop();

    $menuLinks.each(function () {
      var targetId = $(this).attr("href");

      if (targetId && targetId !== "#") {
        var $target = $(targetId);

        if ($target.length) {
          var sectionTop = $target.offset().top - $scrollContainer.offset().top + scrollPos - 120;
          var sectionBottom = sectionTop + $target.outerHeight();

          if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
            $menuLinks.removeClass("active");
            $menuLinks.filter('[href="' + targetId + '"]').addClass("active");
          }
        }
      }
    });
  });
});

$(document).ready(function () {
  var rightCol = document.querySelector(".right-column");
  var mainSection = document.querySelector(".intake_pdp_main");
  var sectionNav = document.querySelector("#mk7-nav-bar");

  if (!rightCol || !mainSection) return;

  var headerH = 126;
  var sectionNavH = sectionNav ? sectionNav.offsetHeight : 0;
  var stickyTop = headerH + sectionNavH;

  var originalParent = rightCol.parentNode;
  var originalNextSibling = rightCol.nextSibling;
  var extraSections = document.querySelectorAll("#MainContent > .shopify-section:not(:first-child)");

  var mode = "none"; // "natural" | "fixed-top" | "fixed-bottom"
  var naturalTop = 0;
  var naturalHeight = 0;
  var naturalWidth = 0;
  var naturalRightOffset = 0;

  function setSectionPadding(paddingPx) {
    extraSections.forEach(function (section) {
      if (paddingPx) {
        section.style.paddingRight = paddingPx + "px";
        section.style.boxSizing = "border-box";
      } else {
        section.style.paddingRight = "";
        section.style.boxSizing = "";
      }
    });
  }

  function clearInline() {
    rightCol.style.position = "";
    rightCol.style.top = "";
    rightCol.style.bottom = "";
    rightCol.style.right = "";
    rightCol.style.width = "";
    rightCol.style.zIndex = "";
    rightCol.style.transform = "";
  }

  function restoreToNaturalParent() {
    if (rightCol.parentNode === document.body && originalParent) {
      if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
        originalParent.insertBefore(rightCol, originalNextSibling);
      } else {
        originalParent.appendChild(rightCol);
      }
    }
  }

  function measureNatural() {
    clearInline();
    restoreToNaturalParent();
    setSectionPadding(0);
    var rect = rightCol.getBoundingClientRect();
    naturalTop = rect.top + window.scrollY;
    naturalHeight = rightCol.offsetHeight;
    naturalWidth = rect.width;
    // Align the column's visual right edge with the page sections' right edge
    // (MainContent.right). In fixed positioning, `right` is measured from the
    // viewport content area (clientWidth), and CSS adds a translateX(17px), so:
    //   visual_right = clientWidth - rightOffset + 17  →  solve for rightOffset.
    var mainContentEl = document.getElementById("MainContent");
    var mainContentRight = mainContentEl
      ? mainContentEl.getBoundingClientRect().right
      : window.innerWidth;
    var CSS_TRANSLATE_X = 17;
    naturalRightOffset = document.documentElement.clientWidth + CSS_TRANSLATE_X - mainContentRight;
  }

  function applyMode(newMode) {
    if (newMode === "natural") {
      if (mode !== "natural") {
        clearInline();
        restoreToNaturalParent();
        setSectionPadding(0);
      }
      // Override the CSS translateX(17px) so the column's visual right edge
      // aligns with MainContent's right edge (matching page sections).
      rightCol.style.transform = "translateX(0)";
      mode = "natural";
      return;
    }

    if (rightCol.parentNode !== document.body) {
      document.body.appendChild(rightCol);
    }
    rightCol.style.transform = "";
    rightCol.style.position = "fixed";
    rightCol.style.right = naturalRightOffset + "px";
    rightCol.style.width = naturalWidth + "px";
    rightCol.style.zIndex = "1000";

    if (newMode === "fixed-top") {
      rightCol.style.top = stickyTop + "px";
      rightCol.style.bottom = "";
    } else { // fixed-bottom
      rightCol.style.top = "";
      rightCol.style.bottom = "20px";
    }
    setSectionPadding(naturalWidth);
    mode = newMode;
  }

  function decideMode() {
    if (window.innerWidth < 1200) {
      applyMode("natural");
      return;
    }

    sectionNavH = sectionNav ? sectionNav.offsetHeight : 0;
    stickyTop = headerH + sectionNavH;

    var availableHeight = window.innerHeight - stickyTop;
    if (naturalHeight <= availableHeight) {
      applyMode("fixed-top");
      return;
    }

    // Column too tall to fit pinned at top. Scroll naturally, then pin bottom.
    var pinThreshold = naturalTop + naturalHeight + 20 - window.innerHeight;
    if (window.scrollY >= pinThreshold) {
      applyMode("fixed-bottom");
    } else {
      applyMode("natural");
    }
  }

  function remeasureAndDecide() {
    measureNatural();
    decideMode();
  }

  remeasureAndDecide();

  window.addEventListener("resize", function () {
    remeasureAndDecide();
  });

  window.addEventListener("scroll", function () {
    decideMode();
  }, { passive: true });

  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-ie-compat-toggle]")) {
      setTimeout(remeasureAndDecide, 0);
    }
  });
});

$(document).ready(function () {
  var navLinks = document.querySelectorAll(".pdp-section-nav__item a");
  if (!navLinks.length) return;

  var sections = Array.from(navLinks)
    .map(function (link) {
      var href = link.getAttribute("href");
      var target = href ? document.querySelector(href) : null;
      return {
        link: link,
        target: target
      };
    })
    .filter(function (section) {
      return section.target;
    });

  var headerH = 126;
  var navH = document.querySelector("#mk7-nav-bar")
    ? document.querySelector("#mk7-nav-bar").offsetHeight
    : 46;
  var offset = headerH + navH + 20;

  function updateNav() {
    var scrollY = window.scrollY;
    var activeIdx = 0;

    sections.forEach(function (section, i) {
      if (section.target.getBoundingClientRect().top + scrollY - offset <= scrollY) {
        activeIdx = i;
      }
    });

    sections.forEach(function (section, i) {
      section.link.classList.remove("active", "visited");

      if (i === activeIdx) {
        section.link.classList.add("active");
      } else if (i < activeIdx) {
        section.link.classList.add("visited");
      }
    });
  }

  window.addEventListener("scroll", updateNav, { passive: true });
  updateNav();

  navLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      var href = this.getAttribute("href");
      var target = document.querySelector(href);

      if (target) {
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }
    });
  });
});

$(document).ready(function () {
  var nav = document.querySelector("#mk7-nav-bar");

  if (nav && window.innerWidth >= 1200) {
    document.body.appendChild(nav);
  }

  window.addEventListener("resize", function () {
    var nav2 = document.querySelector("#mk7-nav-bar");
    if (nav2 && window.innerWidth >= 1200 && nav2.parentNode !== document.body) {
      document.body.appendChild(nav2);
    }
  });
});

console.log("testing, this works this works");

//# sourceMappingURL=/cdn/shop/t/9/assets/mk7-hw-pdp-scripts.js.map?v=1772568042438